import styled from 'styled-components';

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  border-radius: 3px;
  background-color: #efefef;
`;